import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONTRACTABLE_BUFFER, PACKAGE_TYPE, metaSchemas } from "@/lib/constants";
import { gql } from "@apollo/client";
import { createPageInfo, genres, isAllowedRating, isDateRangeIn, largeThumbnailUrl, mediumThumbnailUrl, metaResolveType, ratingMask, smallThumbnailUrl, thumbnailUrl, values } from "./helper";
export const typeDef = gql`
  interface Meta {
    id: ID!
    name: String!
    thumbnailUrl: String
    smallThumbnailUrl: String
    mediumThumbnailUrl: String
    largeThumbnailUrl: String
    header: String
    description: String
    schema_key: String
    copyright: String
    delivery_start_at: String
    delivery_end_at: String
    rights_control_type: String
    parents: [Meta]
    push_rank: String
    rating: String
    isAllowedRating: Boolean
    rights: [Right]
    genres: [Genre]
  }

  type TVShowMeta implements Meta {
    id: ID!
    name: String!
    thumbnailUrl: String
    smallThumbnailUrl: String
    mediumThumbnailUrl: String
    largeThumbnailUrl: String
    header: String
    description: String
    schema_key: String
    copyright: String
    delivery_start_at: String
    delivery_end_at: String
    rights_control_type: String
    parents: [Meta]
    push_rank: String
    rating: String
    isAllowedRating: Boolean
    rights: [Right]
    genres: [Genre]
    production_country: [String]
    cast: String
    staff: String
    production_year: String
    episode_num: Int
    meta_keywords: [String]
    meta_description: String
    channel: Meta
    bookmark: Bookmark
    distributor: String
    course: Course
    rtsid: String
  }

  type SeasonMeta implements Meta {
    id: ID!
    name: String!
    thumbnailUrl: String
    smallThumbnailUrl: String
    mediumThumbnailUrl: String
    largeThumbnailUrl: String
    header: String
    description: String
    schema_key: String
    copyright: String
    delivery_start_at: String
    delivery_end_at: String
    rights_control_type: String
    parents: [Meta]
    push_rank: String
    rating: String
    isAllowedRating: Boolean
    rights: [Right]
    genres: [Genre]
    production_country: [String]
    cast: String
    staff: String
    production_year: String
    episode_count: Int
    meta_keywords: [String]
    meta_description: String
    channel: Meta
  }

  type EpisodeMeta implements Meta {
    id: ID!
    name: String!
    thumbnailUrl: String
    smallThumbnailUrl: String
    mediumThumbnailUrl: String
    largeThumbnailUrl: String
    header: String
    description: String
    schema_key: String
    copyright: String
    delivery_start_at: String
    delivery_end_at: String
    rights_control_type: String
    parents: [Meta]
    push_rank: String
    rating: String
    isAllowedRating: Boolean
    rights: [Right]
    genres: [Genre]
    production_country: [String]
    cast: String
    staff: String
    production_year: String
    distributor: String
    num: Int
    duration: Float
    meta_keywords: [String]
    meta_description: String
    channel: ChannelMeta
    area_control_flag: Boolean
    is_live: Boolean
    tvShow: TVShowMeta
    recommend: Int
    start_over_flag: Boolean
    catch_up_flag: Boolean
    encode_start_date: String
    encode_end_date: String
    resume_point: Int
    last_viewing_at: String
    source_epg_id: String
    plalaFlag: Boolean
    rtsid: String
  }

  type LiveMeta implements Meta {
    id: ID!
    name: String!
    thumbnailUrl: String
    smallThumbnailUrl: String
    mediumThumbnailUrl: String
    largeThumbnailUrl: String
    header: String
    description: String
    schema_key: String
    copyright: String
    delivery_start_at: String
    delivery_end_at: String
    rights_control_type: String
    parents: [Meta]
    push_rank: String
    rating: String
    isAllowedRating: Boolean
    rights: [Right]
    genres: [Genre]
    production_country: [String]
    cast: String
    staff: String
    production_year: String
    distributor: String
    num: Int
    duration: Float
    meta_keywords: [String]
    meta_description: String
    channel: ChannelMeta
    area_control_flag: Boolean
    is_live: Boolean
    tvShow: TVShowMeta
    recommend: Int
    start_over_flag: Boolean
    catch_up_flag: Boolean
    encode_start_date: String
    encode_end_date: String
    resume_point: Int
    last_viewing_at: String
    source_epg_id: String
    plalaFlag: Boolean
    rtsid: String
  }

  type ChannelMetaHeroImage {
    pc: String
    mb: String
  }

  type ChannelMeta implements Meta {
    id: ID!
    name: String!
    thumbnailUrl: String
    smallThumbnailUrl: String
    mediumThumbnailUrl: String
    largeThumbnailUrl: String
    header: String
    description: String
    schema_key: String
    copyright: String
    delivery_start_at: String
    delivery_end_at: String
    rights_control_type: String
    parents: [Meta]
    push_rank: String
    rating: String
    isAllowedRating: Boolean
    rights: [Right]
    genres: [Genre]
    meta_keywords: [String]
    meta_description: String
    live_flag: Boolean
    video_flag: Boolean
    heroImage: ChannelMetaHeroImage
    contractStatus: Boolean @cacheControl(scope: PRIVATE, maxAge: 0)
    contractAllowed: Boolean
    tabMenu: [Link]
    distributor: String
  }
  union MediaMeta = EpisodeMeta | LiveMeta

  type MetaConnection {
    data: [Meta]
    pageInfo: PageInfo
  }

  type ChannelConnection {
    data: [ChannelMeta]
    pageInfo: PageInfo
  }

  enum EpisodeType {
    LIVE_ONAIR
    LIVE_BEFORE
    CATCHUP
    VIDEO
  }

  type Bookmark @cacheControl(maxAge: 0) {
    meta_id: Int
    bookmark_meta_id: Int
    position: Int
    bookmark_meta: Meta
  }

  type EntitledResult @cacheControl(scope: PRIVATE) {
    data: [Meta]
    pageInfo: PageInfo
  }

  type EntitledEpisodesResult @cacheControl(scope: PRIVATE) {
    data: [MediaMeta]
    pageInfo: PageInfo
  }

  type GenrePaletteEpisodesResult {
    data: [MediaMeta]
    pageInfo: PageInfo
  }

  type ChannelByCourseResult {
    id: Int
    name: String
  }

  type Query {
    episode(id: Int): Meta

    nextEpisode(id: Int): Meta

    children(
      id: Int
      offset: Int
      limit: Int
      filter: JSONObject
      sort: JSONObject
    ): MetaConnection

    channels(
      offset: Int
      limit: Int
      filter: JSONObject
      sort: String
    ): ChannelConnection

    channelsWithContractStatus(
      offset: Int
      limit: Int
      filter: JSONObject
      sort: String
      uuid: String
    ): ChannelConnection
    channelDetail(id: Int): ChannelMeta
    channelFeatureEpisodes(id: Int, offset: Int, limit: Int): MetaConnection

    channelEpisodeSearch(
      keyword: String
      id: Int
      episodeType: EpisodeType
      offset: Int
      limit: Int
    ): MetaConnection

    channelLiveSchedule(
      id: Int
      day: String
      offset: Int
      limit: Int
    ): MetaConnection

    channelLinearEpisodes(
      id: Int
      filter: JSONObject
      offset: Int
      limit: Int
    ): MetaConnection

    search(
      keyword: String
      filter: JSONObject
      sort: String
      offset: Int
      limit: Int
      minScore: Int
    ): MetaConnection

    searchTvShow(
      keyword: String
      filter: JSONObject
      sort: String
      offset: Int
      limit: Int
      minScore: Int
    ): MetaConnection

    title(id: Int): TVShowMeta

    titles(
      filter: JSONObject
      sort: String
      offset: Int
      limit: Int
    ): MetaConnection

    entitled(
      channelId: Int
      contentType: String
      offset: Int
      limit: Int
    ): EntitledResult

    getEntitledStoreEpisodes(offset: Int, limit: Int): EntitledEpisodesResult

    genrePaletteEpisodes(
      channel: Int
      genre: [Int]
      offset: Int
      limit: Int
      sortOrder: String
      type: String
    ): GenrePaletteEpisodesResult
  }
`;
async function getUserRightIds(dataSources, info) {
  info.cacheControl.setCacheHint({
    scope: "PRIVATE"
  });
  const userRightIds = await dataSources.user.rightIds();
  return userRightIds;
}
export const resolvers = {
  Query: {
    episode: async (_parent, _ref, _ref2) => {
      let {
        id
      } = _ref;
      let {
        dataSources
      } = _ref2;
      const res = await dataSources.episodes.getEpisode(id);
      const meta = res.metas[0];
      return meta;
    },
    nextEpisode: async (_parent, _ref3, _ref4) => {
      let {
        id
      } = _ref3;
      let {
        dataSources
      } = _ref4;
      try {
        const meta = await dataSources.episodes.nextEpisode(id);
        // nextがない時は204でbodyがから文字で返ってくる
        if (typeof meta === "string") {
          return null;
        } else {
          return meta;
        }
      } catch (e) {
        return null;
      }
    },
    children: async (_parent, args, _ref5) => {
      let {
        dataSources
      } = _ref5;
      const res = await dataSources.meta.children(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    channels: async (_parent, args, _ref6) => {
      let {
        dataSources
      } = _ref6;
      const res = await dataSources.meta.channels(args);
      const data = res === null || res === void 0 ? void 0 : res.metas;
      return {
        data,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    channelsWithContractStatus: async (_parent, args, _ref7) => {
      let {
        dataSources
      } = _ref7;
      const res = await dataSources.meta.channels(args);
      const data = res === null || res === void 0 ? void 0 : res.metas;
      return {
        data,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    channelFeatureEpisodes: async (_parent, args, _ref8) => {
      let {
        dataSources
      } = _ref8;
      const res = await dataSources.meta.channelFeatureEpisodes(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    channelDetail: async (_parent, _ref9, _ref10) => {
      let {
        id
      } = _ref9;
      let {
        dataSources
      } = _ref10;
      const channel = await dataSources.meta.channelDetail(id);
      return channel;
    },
    channelEpisodeSearch: async (_parent, _ref11, _ref12) => {
      let {
        keyword,
        id,
        episodeType,
        offset,
        limit
      } = _ref11;
      let {
        dataSources
      } = _ref12;
      const filter = {
        "values.channel": id
      };
      switch (episodeType) {
        case "LIVE_ONAIR":
          filter["values.is_live"] = true;
          filter.time_range = {
            "values.encode_start_date": {
              lte: "now"
            },
            "values.encode_end_date": {
              gt: "now"
            }
          };
          break;
        case "LIVE_BEFORE":
          filter["values.is_live"] = true;
          filter.time_range = {
            "values.encode_start_date": {
              gt: "now"
            }
          };
          break;
        case "CATCHUP":
          filter["values.is_live"] = true;
          filter["values.catch_up_flag"] = true;
          filter.time_range = {
            "values.encode_end_date": {
              lt: "now"
            },
            delivery_end_at: {
              gt: "now"
            }
          };
          break;
        case "VIDEO":
          filter["values.is_live"] = false;
          break;
      }
      const res = await dataSources.meta.searchEpisode({
        keyword,
        filter,
        offset,
        limit
      });
      return {
        data: res.metas,
        pageInfo: createPageInfo({
          offset,
          limit,
          count: res.total_count
        })
      };
    },
    channelLiveSchedule: async (_parent, args, _ref13) => {
      let {
        dataSources
      } = _ref13;
      const res = await dataSources.meta.channelLiveSchedule(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    channelLinearEpisodes: async (_parent, args, _ref14) => {
      let {
        dataSources
      } = _ref14;
      const res = await dataSources.meta.channelLinearEpisodes(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    search: async (_parent, args, _ref15) => {
      let {
        dataSources
      } = _ref15;
      const res = await dataSources.meta.searchEpisode(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    searchTvShow: async (_parent, args, _ref16) => {
      let {
        dataSources
      } = _ref16;
      const res = await dataSources.meta.searchTvShow(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    title: async (_parent, _ref17, _ref18) => {
      let {
        id
      } = _ref17;
      let {
        dataSources
      } = _ref18;
      const title = await dataSources.meta.title(id);
      return title;
    },
    titles: async (_parent, args, _ref19) => {
      let {
        dataSources
      } = _ref19;
      const res = await dataSources.meta.titles(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    entitled: async (_parent, args, _ref20) => {
      let {
        dataSources
      } = _ref20;
      const res = await dataSources.meta.entitled(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    getEntitledStoreEpisodes: async (_parent, args, _ref21) => {
      let {
        dataSources
      } = _ref21;
      const res = await dataSources.meta.getEntitledStoreEpisodes(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    },
    genrePaletteEpisodes: async (_parent, args, _ref22) => {
      let {
        dataSources
      } = _ref22;
      const res = await dataSources.meta.genrePaletteEpisodes(args);
      return {
        data: res.metas,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    }
  },
  Meta: {
    __resolveType: metaResolveType
  },
  TVShowMeta: {
    thumbnailUrl,
    smallThumbnailUrl,
    mediumThumbnailUrl,
    largeThumbnailUrl,
    name: (obj, _args, _ref23) => {
      let {
        req
      } = _ref23;
      return ratingMask(req, obj, "name");
    },
    description: (obj, _args, _ref24) => {
      let {
        req
      } = _ref24;
      return ratingMask(req, obj, "description");
    },
    rights: obj => values(obj, "rights"),
    genres,
    rating: obj => values(obj, "rating"),
    isAllowedRating: (obj, _args, _ref25) => {
      let {
        req
      } = _ref25;
      return isAllowedRating(req, obj);
    },
    meta_keywords: obj => values(obj, "meta_keywords"),
    meta_description: obj => values(obj, "meta_description"),
    channel: obj => values(obj, "channel"),
    episode_num: obj => values(obj, "episode_num"),
    bookmark: async (parent, _args, _ref26) => {
      let {
        dataSources
      } = _ref26;
      const bookmark = await dataSources.user.viewingBookmarkFromMeta(parent.id);
      if (bookmark && bookmark.position < bookmark.bookmark_meta.duration) {
        return bookmark;
      } else {
        var _bookmark$bookmark_me, _children$metas;
        const children = await dataSources.meta.children({
          id: parent.id,
          filter: {
            range: {
              "values.num": {
                gt: (bookmark === null || bookmark === void 0 || (_bookmark$bookmark_me = bookmark.bookmark_meta) === null || _bookmark$bookmark_me === void 0 ? void 0 : _bookmark$bookmark_me.num) || 0
              }
            }
          },
          offset: 0,
          limit: 1
        });
        const meta = children === null || children === void 0 || (_children$metas = children.metas) === null || _children$metas === void 0 ? void 0 : _children$metas[0];
        if (meta) {
          return {
            meta_id: parent.id,
            bookmark_meta_id: meta.id,
            position: 0,
            bookmark_meta: meta
          };
        } else {
          return bookmark;
        }
      }
    },
    course: async (meta, _args, _ref27) => {
      var _meta$values, _right$values;
      let {
        dataSources
      } = _ref27;
      const right = meta === null || meta === void 0 || (_meta$values = meta.values) === null || _meta$values === void 0 || (_meta$values = _meta$values.rights) === null || _meta$values === void 0 ? void 0 : _meta$values[0];
      if ((right === null || right === void 0 || (_right$values = right.values) === null || _right$values === void 0 ? void 0 : _right$values.package_type) === PACKAGE_TYPE["svod"]) {
        const courses = await dataSources.right.courses(right.id);
        return courses.courses[0];
      } else {
        return null;
      }
    }
  },
  SeasonMeta: {
    thumbnailUrl,
    smallThumbnailUrl,
    mediumThumbnailUrl,
    largeThumbnailUrl,
    name: (obj, _args, _ref28) => {
      let {
        req
      } = _ref28;
      return ratingMask(req, obj, "name");
    },
    description: (obj, _args, _ref29) => {
      let {
        req
      } = _ref29;
      return ratingMask(req, obj, "description");
    },
    rights: obj => values(obj, "rights"),
    genres,
    rating: obj => values(obj, "rating"),
    isAllowedRating: (obj, _args, _ref30) => {
      let {
        req
      } = _ref30;
      return isAllowedRating(req, obj);
    },
    meta_keywords: obj => values(obj, "meta_keywords"),
    meta_description: obj => values(obj, "meta_description"),
    channel: obj => values(obj, "channel")
  },
  EpisodeMeta: {
    thumbnailUrl,
    smallThumbnailUrl,
    mediumThumbnailUrl,
    largeThumbnailUrl,
    name: (obj, _args, _ref31) => {
      let {
        req
      } = _ref31;
      return ratingMask(req, obj, "name");
    },
    description: (obj, _args, _ref32) => {
      let {
        req
      } = _ref32;
      return ratingMask(req, obj, "description");
    },
    rights: obj => values(obj, "rights"),
    genres,
    rating: obj => values(obj, "rating"),
    isAllowedRating: (obj, _args, _ref33) => {
      let {
        req
      } = _ref33;
      return isAllowedRating(req, obj);
    },
    meta_keywords: obj => values(obj, "meta_keywords"),
    meta_description: obj => values(obj, "meta_description"),
    channel: obj => values(obj, "channel"),
    area_control_flag: obj => values(obj, "area_control_flag"),
    is_live: obj => values(obj, "is_live"),
    production_year: obj => values(obj, "production_year"),
    distributor: obj => values(obj, "distributor"),
    tvShow: obj => obj.parents.find(meta => meta.schema_id == metaSchemas.tvshow.id),
    recommend: obj => values(obj, "recommend"),
    source_epg_id: obj => values(obj, "source_epg_id"),
    plalaFlag: obj => values(obj, "plala_flag"),
    start_over_flag: obj => values(obj, "start_over_flag"),
    catch_up_flag: obj => values(obj, "catch_up_flag"),
    encode_start_date: obj => values(obj, "encode_start_date"),
    encode_end_date: obj => values(obj, "encode_end_date")
  },
  LiveMeta: {
    thumbnailUrl,
    smallThumbnailUrl,
    mediumThumbnailUrl,
    largeThumbnailUrl,
    name: (obj, _args, _ref34) => {
      let {
        req
      } = _ref34;
      return ratingMask(req, obj, "name");
    },
    description: (obj, _args, _ref35) => {
      let {
        req
      } = _ref35;
      return ratingMask(req, obj, "description");
    },
    rights: obj => values(obj, "rights"),
    genres,
    rating: obj => values(obj, "rating"),
    isAllowedRating: (obj, _args, _ref36) => {
      let {
        req
      } = _ref36;
      return isAllowedRating(req, obj);
    },
    meta_keywords: obj => values(obj, "meta_keywords"),
    meta_description: obj => values(obj, "meta_description"),
    channel: obj => values(obj, "channel"),
    area_control_flag: obj => values(obj, "area_control_flag"),
    is_live: obj => values(obj, "is_live"),
    production_year: obj => values(obj, "production_year"),
    distributor: obj => values(obj, "distributor"),
    start_over_flag: obj => values(obj, "start_over_flag"),
    catch_up_flag: obj => values(obj, "catch_up_flag"),
    encode_start_date: obj => values(obj, "encode_start_date"),
    encode_end_date: obj => values(obj, "encode_end_date"),
    tvShow: obj => obj.parents.find(meta => meta.schema_id == metaSchemas.tvshow.id),
    recommend: obj => values(obj, "recommend"),
    source_epg_id: obj => values(obj, "source_epg_id"),
    plalaFlag: obj => values(obj, "plala_flag")
  },
  ChannelMeta: {
    thumbnailUrl,
    smallThumbnailUrl,
    mediumThumbnailUrl,
    largeThumbnailUrl,
    name: (obj, _args, _ref37) => {
      let {
        req
      } = _ref37;
      return ratingMask(req, obj, "name");
    },
    description: (obj, _args, _ref38) => {
      let {
        req
      } = _ref38;
      return ratingMask(req, obj, "description");
    },
    rights: obj => values(obj, "rights"),
    genres,
    rating: obj => values(obj, "rating"),
    isAllowedRating: (obj, _args, _ref39) => {
      let {
        req
      } = _ref39;
      return isAllowedRating(req, obj);
    },
    meta_keywords: obj => values(obj, "meta_keywords"),
    meta_description: obj => values(obj, "meta_description"),
    live_flag: obj => values(obj, "live_flag"),
    video_flag: obj => values(obj, "video_flag"),
    heroImage: obj => obj.hero_image,
    distributor: obj => values(obj, "distributor"),
    contractStatus: async (parent, _args, _ref40, info) => {
      let {
        req,
        dataSources
      } = _ref40;
      if (req.userToken) {
        const userRightIds = await getUserRightIds(dataSources, info);
        const rights = parent.values.rights;
        const contract = rights.find(right => userRightIds.includes(right.id));
        return !!contract;
      }
      return false;
    },
    contractAllowed: channel => {
      var _channel$values;
      const right = channel === null || channel === void 0 || (_channel$values = channel.values) === null || _channel$values === void 0 || (_channel$values = _channel$values.rights) === null || _channel$values === void 0 ? void 0 : _channel$values[0];
      if (right) {
        var _right$values2, _right$values3;
        return isDateRangeIn(right === null || right === void 0 || (_right$values2 = right.values) === null || _right$values2 === void 0 ? void 0 : _right$values2.delivery_start_date, right === null || right === void 0 || (_right$values3 = right.values) === null || _right$values3 === void 0 ? void 0 : _right$values3.delivery_end_date, {
          buffer: CONTRACTABLE_BUFFER,
          default: true
        });
      }
      return false;
    },
    tabMenu: async (parent, _args, _ref41) => {
      var _parent$values;
      let {
        dataSources
      } = _ref41;
      if (parent !== null && parent !== void 0 && (_parent$values = parent.values) !== null && _parent$values !== void 0 && _parent$values.detail_tab_menu) {
        var _parent$values2;
        const res = await dataSources.linkSet.linkSet(parent === null || parent === void 0 || (_parent$values2 = parent.values) === null || _parent$values2 === void 0 ? void 0 : _parent$values2.detail_tab_menu);
        return res === null || res === void 0 ? void 0 : res.links;
      }
    }
  },
  MediaMeta: {
    __resolveType: metaResolveType
  }
};